import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";  // Import useNavigate instead of useHistory
import BreadCrumb from "../components/BreadCrumb";
import { Link } from "react-router-dom";

const Dashboard = () => {
  const navigate = useNavigate();  // Initialize useNavigate hook
const user = JSON.parse(localStorage.getItem("user"));
  const handleLogout = () => {
    // Remove token from localStorage or sessionStorage
    localStorage.removeItem("token");

    // Redirect to login page
    navigate("/login");  // Use navigate() to redirect
  };

  useEffect(() => {
    // Check if the token exists when the component mounts, and if not, redirect to login
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");  // Use navigate() to redirect
    }
  }, [navigate]);  // Empty dependency array means this runs once when the component mounts

  return (
    <div className="dashboard">
      <BreadCrumb />
      <h1>Welcome to {user?.name} the Dashboard</h1>
      <div>
        <button onClick={handleLogout}>Logout</button>
      </div>
    </div>
  );
};

export default Dashboard;
